import * as React from 'react';
import { Note, User, UserNote, UserStyle } from '../../../models';
import { PVAContainer, PVAContentHeader, PVAContentBody, PVABadge, PVADiamond, PVAMultiSelect } from '../../../components';
import { ReportType } from '../../../enums';
import { BaseRouteProps } from '../../../interfaces';
import { FilterStore, UserStore } from '../../../stores';
import { NoteDataService, UserDataService } from '../../../services';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { NavLink } from 'react-router-dom';
import './notes.css';
import { PonderaModal } from '../../inclinationmodals';

interface MyReportState {
    selectedUserData: any;
    reportType: ReportType;
    sticky: boolean;
    stickySize: number;
    stickyGroups: number[];
    groupPos: number[];
    activeInd: number;
    currSurveyId: number;
    currSurveyVersionId: number;
    loading: boolean;
    notes: Note[];
    selectedNote: Note | undefined;
    users: User[];
    selectedUserIds: number[];
}

interface MyReportProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('FilterStore', 'UserStore') @observer
export class Notes extends React.Component<MyReportProps, MyReportState> {
    private noteDataService = new NoteDataService(this.props.notificationService);
    private userDataService = new UserDataService(this.props.notificationService);

    constructor(props: MyReportProps) {
        super(props);

        this.state = {
            selectedUserData: null,
            reportType: ReportType.Standard,
            sticky: false,
            stickySize: 0,
            stickyGroups: [],
            groupPos: [],
            activeInd: -1,
            currSurveyId: 0,
            currSurveyVersionId: 0,
            loading: false,
            notes: [],
            selectedNote: undefined,
            users: [],
            selectedUserIds: []
        };
    }

    @computed get userRole() {
        if (this.props.UserStore && this.props.UserStore.userLoaded) {
            return this.props.UserStore!.userInfo.userRole;
        }
        return null;
    }

    @computed get userId() {
        if (this.props.UserStore && this.props.UserStore.userLoaded) {
            return this.props.UserStore!.userInfo.id;
        }
        return 0;
    }

    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }
    
    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    componentDidMount() {
        if (this.organization && this.organization.id) {
            this.userDataService.getByOrganizationLight(this.organization.id).then((users: User[]) => {
                this.setState({
                    users: users
                });
            });
        }

        this.noteDataService.getAll().then((notes: Note[]) => {
            this.setState({
                notes: notes
            });
        });
    }

    private noteSelect(note: Note) {
        this.setState({
            selectedNote: note
        });
    }

    private getPVABadge(styles: UserStyle[]) {
        if (styles && styles.length > 0) {
            return <span className="pva-badge-tiny pva-badge-space-left"><PVABadge style={styles[0].style.name} badge={styles[0].style.name[0]} /></span>;
        } else {
            return <span className="pva-badge-tiny pva-badge-space-left"><PVABadge style={''} badge={''} /></span>;
        }
    }

    private canAccessEdit() {
        if (this.state.selectedNote && this.state.selectedNote.id) {
            if (this.userRole === 'siteAdmin' || this.userRole === 'superAdmin') {
                return true;
            }
            if (this.state.selectedNote.userID === this.userId) {
                return true;
            }
        }
        return false;
    }

    private showEdit() {
        if (this.state.selectedNote && this.state.selectedNote.id && this.canAccessEdit()) {
            return (
            <NavLink className="btn btn-primary" to={'/notes/edit/' + this.state.selectedNote.id}>
                <span className="glyphicon glyphicon-edit" /> Edit
            </NavLink>
            );
        }

        return;
    }

    private exportPDF(id: number) {
        this.setState({
            loading: true
        });
        this.noteDataService.getPDF(id).then(() => {
            this.setState({
                loading: false
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    }
    
    toggleUserSelect(e: any) {
        var id = Number(e.target.value);
        if (id === -1) {
            // select all users
            var tempids: number[] = [];
            this.users.map((u: User) => {
                tempids.push(u.id);
            });
            this.setState({
                selectedUserIds: tempids
            });
            return;
        }
        if (id === -2) {
            // deselect all users
            this.setState({
                selectedUserIds: []
            });
            return;
        }

        var ids = this.state.selectedUserIds;
        var ind = ids.indexOf(id);
        if (ind > -1) {
            ids.splice(ind, 1);
        } else {
            ids.push(id);
        }
        this.setState({
            selectedUserIds: ids
        });
    }

    private filterByUser(n: Note) {
        if (this.state.selectedUserIds.length === 0) {
            return true;
        }
        var findIds = this.state.selectedUserIds;
        var foundAll = true;
        findIds.map((id: number) => {
            var ind = n.userNotes.findIndex((un: UserNote) => {
                return un.user.id === id;
            });
            if (ind === -1) {
                foundAll = false;
            }
        });

        return foundAll;
    }

    public render() {
        var content = <div />;
        if (this.state.selectedNote) {
            content = (
                <div className="note-content">
                    <div>
                        <div className="" dangerouslySetInnerHTML={{__html: this.state.selectedNote.content}} />
                        <br />
                    </div>
                    {this.state.selectedNote.userNotes.length > 0 && <div>
                            <div className="light">
                                <span className="pva-info-subtitle">People Involved</span>
                            </div>
                            <br />
                            <div>
                                {this.state.selectedNote.userNotes.map((userNote: UserNote, userInd: number) => {
                                    return <div key={`note-user-${userInd}`} style={{height: '32px', display: 'inline-block'}}>
                                        <span className="user-label tinted">{userNote.user.firstName} {userNote.user.lastName} {this.getPVABadge(userNote.user.userStyles)}</span>
                                    </div>;
                                })}
                            </div>
                        </div>
                    }
                </div>);
        }

        var noteContent = (
            <ul className="note-viewer">
            {this.state.notes.filter(this.filterByUser.bind(this)).map((note: Note, ind: number) => {
                
                return <li className={(this.state.selectedNote && note.id === this.state.selectedNote.id) ? 'selected wrap' : 'wrap'} key={`note-${ind}`} onClick={(e) => this.noteSelect(note)}>
                    <div className="row">
                        <div className="col-xs-6">
                            <div>{note.subject}</div>
                            <div>{this.niceDate(note.created)}</div>
                        </div>
                        <div className="col-xs-6 text-right">
                            {note.userNotes.map((userNote: UserNote, userInd: number) => {
                                return <div key={`note-user-${userInd}`} style={{height: '32px', display: 'inline-block'}}>
                                    <span className="user-label tinted">{userNote.user.firstName} {userNote.user.lastName} {this.getPVABadge(userNote.user.userStyles)}</span>
                                </div>;
                            })}
                        </div>
                    </div>
                    </li>;
            })}
            </ul>);
            
        const icon = <PVADiamond style={''} step={0} />;

        var defaultUserOptions: any[] = [{
            id: -2,
            value: 'No Individuals'
        }, {
            id: -1,
            value: 'All Individuals'
        }];

        return (
            <div className="site-content-inner">
                <PVAContentHeader>
                        <div className="row">
                            <div className="col-xs-7">
                                <span className="title">
                                    Exchange Notes
                                </span>
                                <div style={{paddingLeft: '10px', display: 'inline-block'}}>
                                    <PVAMultiSelect defaultOptions={defaultUserOptions} options={this.users}  selected={this.state.selectedUserIds} onChange={(e: any) => this.toggleUserSelect(e)} FilterStore={this.props.FilterStore} />
                                </div>
                            </div>
                            <div className="col-xs-5 text-right">
                                {this.userRole !== 'user' && <NavLink className="btn btn-primary" to="/notes/create">
                                    <span className="glyphicon glyphicon-plus" /> Create
                                </NavLink>}
                            </div>
                        </div>
                    </PVAContentHeader>
                
                <PVAContentBody>
                    <PVAContainer icon={icon} title={'Notes'} content={noteContent} id="" open={false} clickableHeader={true} />
                    {this.state.selectedNote && <PonderaModal simpleTitle={true} title={this.state.selectedNote.subject} content={''} complexContent={content} show={true} onHide={(e: any) => this.setState({selectedNote: undefined})} footer={this.niceDate(this.state.selectedNote.created)} additional={this.buttons()} />}
                </PVAContentBody>
            </div>);
    }

    private niceDate(d: any) {
        var date = new Date(d);
        return <div><small style={{color: '#aaa'}}>{(date.getMonth() + 1)}/{date.getDate()}/{date.getFullYear()}</small></div>;
    }

    private delete() {
        if (!this.state.selectedNote) {
            return;
        }
        this.noteDataService.delete(this.state.selectedNote).then(() => {
            
            this.noteDataService.getAll().then((notes: Note[]) => {
                this.setState({
                    selectedNote: undefined,
                    notes: notes
                });
            });
        });
    }

    private showDelete() {
        if (this.userRole === 'superAdmin' || this.userRole === 'siteAdmin') {
            return <a className="btn btn-danger" onClick={(e) => this.state.selectedNote && this.delete()}>Delete</a>;
        }
        return <span />;
    }

    private buttons() {
        return (
            <div className="text-left" style={{display: 'inline-block', paddingRight: '5px'}}>
                {!this.state.loading && <a className="btn btn-primary" onClick={(e) => this.state.selectedNote && this.exportPDF(this.state.selectedNote.id)}>Export PDF</a>}
                {this.state.loading && <button disabled={true} className="btn btn-primary">Generating...</button>}
                {this.showDelete()}
                {this.showEdit()}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/notes/Notes.tsx